import { makeStyles } from "@material-ui/styles";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TreeItem from "@mui/lab/TreeItem";
import TreeView from "@mui/lab/TreeView";
import { Checkbox, FormControlLabel, Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { SEGMENTS_MAIN } from "./consts/segments_main";

const useStyles = makeStyles({
  root: {
    height: 600,
    width: 550,
    overflow: "auto",
  },
  labelContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    minWidth: 0,
  },
  formControlLabel: {
    width: "100%",
    margin: 0,
    "& .MuiFormControlLabel-label": {
      width: "100%",
      marginLeft: 8,
    },
  },
  audience: {
    fontSize: "0.875rem",
    color: "#666",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
})

export default function ControlledTreeView({ edit = false, value, onChange }) {
  const INTERESTS = {
    "id": "0",
    name: "root node",
    children: SEGMENTS_MAIN
  };
  const classes = useStyles();
  const [selected, setSelected] = React.useState(value || []);

  useEffect(() => onChange(selected), [selected]);

  function getChildById(node, id) {
    let array = [];

    function getAllChild(nodes) {
      if (nodes === null) return [];
      array.push(nodes.iabCode || nodes.id);
      if (Array.isArray(nodes.children)) {
        nodes.children.forEach((node) => {
          array = [...array, ...getAllChild(node)];
          array = array.filter((v, i) => array.indexOf(v) === i);
        });
      }
      return array;
    }

    function getNodeById(nodes, id) {
      if (nodes.id === id || nodes.iabCode === id) {
        return nodes;
      } else if (Array.isArray(nodes.children)) {
        let result = null;
        nodes.children.forEach((node) => {
          // eslint-disable-next-line no-extra-boolean-cast
          if (!!getNodeById(node, id)) {
            result = getNodeById(node, id);
          }
        });
        return result;
      }

      return null;
    }

    return getAllChild(getNodeById(node, id));
  }

  function getOnChange(checked, nodes) {
    const allNode = getChildById(INTERESTS, nodes.id || nodes.iabCode);
    let array = checked
      ? [...selected, ...allNode]
      : selected.filter((value) => !allNode.includes(value));

    setSelected(array);
  }

  function formatAudience(audience) {
    if (!audience) return "";
    return new Intl.NumberFormat("ru-RU").format(audience);
  }

  function isSelected(node) {
    const code = node.iabCode || node.id;
    return selected.some((item) => item === code);
  }
  
  const RenderTreeWithCheckboxes = (nodes) => {
    const code = nodes.iabCode || nodes.id;
    return (
      <TreeItem
        key={code}
        nodeId={code.toString()}
        label={
          <FormControlLabel
            className={classes.formControlLabel}
            control={
              <Checkbox
                checked={isSelected(nodes)}
                onChange={edit ? edit : (event) =>
                  getOnChange(event.currentTarget.checked, nodes)
                }
              />
            }
            label={
              <Box className={classes.labelContainer}>
                <Typography component="span" sx={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}>{nodes.name}</Typography>
                {nodes.audience && (
                  <Typography component="span" className={classes.audience}>
                    {formatAudience(nodes.audience)}
                  </Typography>
                )}
              </Box>
            }
            key={code}
          />
        }
      >
        {Array.isArray(nodes.children)
          ? nodes.children.map((node) => RenderTreeWithCheckboxes(node))
          : null}
      </TreeItem>

    );
  };

  return (
    <TreeView
      className={classes.root}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
    >
      {INTERESTS.children?.map((node) => RenderTreeWithCheckboxes(node))}
    </TreeView>
  );
}

